import {Component, Module} from 'app/decorators';

import CustomerPicker from 'app/directives/customer.picker';
import CustomersComponent from './customers.component';
import CustomerCardComponent from './customer.card.component';

import splitBillingTpl from './edit.modal.html';
import tpl from './billing.html';


class SplitBillingCtrl {
    constructor ($uibModalInstance, R, object, customers) {
        "ngInject";
        this.R = R;
        this.$modal = $uibModalInstance;
        this.object = object;
        this.customers = customers;
        this.data = this.R.copy(this.customers);
    }

    get title () {
        return `Order #${ this.object.id } - ${ this.object.customer.title } #${ this.object.customer.id }`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        this.object.one('billing').customPUT(this.data).then(function (data) {
            self.$modal.close(data);
        });
    }
}


@Module({
    name: "app.directives.billing",
    modules: [
        CustomerPicker,
        CustomersComponent,
        CustomerCardComponent,
    ],
})
@Component({
    selector: 'blnd-billing-component',
    bindings: {
        ngModel: '=',
        editPerm: '<',
    },
    template: tpl,
})
export default class BillingComponent {
    constructor (Modal, $growl) {
        "ngInject";
        let self = this;
        this.Modal = Modal;
        this.$growl = $growl;
        this.customers = [];

        this.ngModel.all('billing').getList().then(function (data) {
            self.customers = data;
        });
    }

    openSplitModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: splitBillingTpl,
            controller: SplitBillingCtrl,
            size: 'lg',
            resolve: {
                object: () => this.ngModel,
                customers: () => this.customers,
            },
        });

        $modal.result.then(function(order){
            self.customers = order;
            self.$growl.updated();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/billing/component.js